module.exports = __webpack_public_path__ + "img/home_menu_12_selected.59ec2fc1.png";